import React, { Component } from 'react';

import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import CpcTable from './components/CpcTable';

import API from '../../services/API';

class BidderCpc extends Component {

    constructor() {
        super();

        this.state = {
            countries: [ ],
            cpc: null,
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit({ countries }) {
        this.setState({
            isLoading: true
        });

        API.BidderCPC.get(countries).then(cpc => {
            this.setState({ countries, cpc, isLoading: false });
        });
    }

    getTable() {
        const { cpc } = this.state;

        return cpc ?
            <CpcTable countries={this.state.countries} cpc={this.state.cpc} /> :
            <p>No Data</p>
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Bidder CPC"/>
                <Form onSubmit={this.handleSubmit}/>
                {this.getTable()}
            </Container>
        );
    }
}

export default BidderCpc;


// WEBPACK FOOTER //
// ./src/scenes/BidderCpc/index.js